import { initialState } from "./state"

export default {
  setLoading: (state, payload) => (state.loading = payload),
  setTerm: (state, payload) => {
    state.term = payload

    if (payload?.cities?.length) {
      state.citiesSelecteds = payload.cities.map(city => ({
        text: city.name,
        value: city.uuid,
        state: city.state?.letter || ""
      }))
    }
  },
  setTermDesc: (state, payload) => (state.term.termDesc = payload),
  setTermSummary: (state, payload) => (state.term.summary = payload),
  setTermName: (state, payload) => (state.term.termName = payload),
  setCreatingTerm: (state, payload) => (state.creatingTerm = payload),
  setTermViewOnly: (state, payload) => (state.viewOnlyTerm = payload),
  setActivateTermInEdit: (state, payload) => (state.activateTermInEdit = payload),
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updateLayout(state, param) {
    state.layout = { ...state.layout, ...param }
  },
  updateTerm(state, param) {
    state.term = { ...state.term, ...param }
  },
  resetTermAudit: (state) => {
    const INITIAL_STATE = initialState()
    Object.keys(INITIAL_STATE).forEach((key) => {
      state[key] = INITIAL_STATE[key]
    })
  },
  setCoverageOptions(state, payload) {
    state.coverageOptions = payload
  },
  updateCoverageOption(state, { index, prop, newValue, data }) {
    const option = state.coverageOptions[index]

    state.coverageOptions.splice(index, 1, {
      ...option,
      ...(data || { [prop]: newValue })
    })
  },
  setCoverageCityStateSelected(state, payload) {
    state.cityStateSelected = payload
  },
  setCoverageCitySelecteds: (state, payload) => {
    (state.citiesSelecteds = payload)
  },
  addCoverageCitySelected(state, payload) {
    state.citiesSelecteds.push(payload)
  },
  deleteCoverageCitySelected(state, index) {
    state.citiesSelecteds.splice(index, 1)
  }
}
